<template>
  <CheckboxBasic
    v-model="inputValue"
    :name="name"
    :options="options"
    :required="required"
    :spacing="spacing"
    :has-error="required && !!errorMessage"
  />
  <div
    v-if="errorMessage"
    :id="'checkbox'+id"
    aria-live="polite"
    :class="['form-error', {'is-visible': errorMessage}]"
  >
    <Icon
      role="graphics-symbol"
      :icon="csgErrorRed"
      :aria-label="errorMessage? 'Error' : ''"
      :aria-hidden="!errorMessage"
    />
    <span>{{ errorMessage }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useField } from 'vee-validate';
import { csgErrorRed } from '@csgSvgIcons/icons';
import CheckboxBasic from '../checkboxBasic/CheckboxBasic';
import generateRandomId from '../../utils/randomNumber';
import Icon from '../icon';

const props = defineProps({
  name: {
    type: String,
    default: 'checkbox',
  },
  options: {
    type: Array,
    default: () => [],
  },
  required: {
    type: Boolean,
    default: true,
  },
  spacing: {
    type: String,
    default: 'margin-bottom-xxs',
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
});
const emit = defineEmits(['update:modelValue']);
const inputValue = computed({
  get() {
    return props.modelValue;
  },
  set(updatedValue) {
    emit('update:modelValue', updatedValue);
  },
});
const { errorMessage } = useField(props.name, (selectedValues) => {
  if (!props.required) {
    return '';
  }
  if (props.required && selectedValues.length > 0) {
    return '';
  }
  return `${props.name} is required.`;
}, {
  type: 'checkbox',
  initialValue: props.modelValue,
});
const id = generateRandomId();
</script>

<style lang="scss" scoped>
@import "~@core/csg/src/scss/forms/forms.scss";
@include csg-forms;

.checkbox-container {
  +.form-error.is-visible {
    margin-top: rem-calc(8);
  }
}

.checkbox-container:only-of-type {
  +.form-error.is-visible {
    margin-top: rem-calc(16);
  }
}
</style>
